import { render, staticRenderFns } from "./freeze-dialog.vue?vue&type=template&id=05e0458e&scoped=true&"
import script from "./freeze-dialog.vue?vue&type=script&lang=ts&"
export * from "./freeze-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./freeze-dialog.vue?vue&type=style&index=0&id=05e0458e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e0458e",
  null
  
)

export default component.exports